export const theme = {
	badge: {
		fontWeight: 500,
		borderRadius: '999px'
	}
};

export type Theme = typeof theme;
